import React from "react";
import { IntlContextConsumer, changeLocale } from "gatsby-plugin-react-intl";

import styled from "styled-components";

const languageName = { "pt-br": "PT", "en-us": "EN", "es-es": "ES" };

export function ToggleLang() {
  return (
    <ToggleLangWrapper>
      <IntlContextConsumer>
        {({ languages, language: currentLocale }) =>
          languages.map((language) => (
            <Button
              data-testid={`toggle-lang-${language}`}
              key={language}
              onClick={() => changeLocale(language)}
              className={`${currentLocale === language ? "active" : ""}`}
            >
              <span>{languageName[language]}</span>
            </Button>
          ))
        }
      </IntlContextConsumer>
    </ToggleLangWrapper>
  );
}

const ToggleLangWrapper = styled.div``;
const Button = styled.button`
  font-size: 12.6px;
  line-height: 22px;
  border: none;
  padding: 6px;
  position: relative;
  color: #999999;
  font-weight: bold;
  opacity: 0.5;

  background-color: #222;

  transition: all 0.2s;

  :not(:first-child) {
    margin-left: 12px;
  }

  &.active {
    padding: 6px;
    opacity: 1;
    color: #fff;

    ::after {
      content: "";
      height: 4px;
      width: 4px;
      background: var(--orange);
      position: absolute;
      bottom: 2px;
      left: 0px;
      right: 0px;
      margin: auto;
      border-radius: 50%;
    }
  }

  :hover {
    color: var(--orange);
    opacity: 1;
  }
`;
